import { getI18n } from 'react-i18next';

export const getApiErrorMessage = (err: any, fallback?: string): string => {
  const { language } = getI18n();
  const apiError = err?.response?.data;
  const isArabic = language === 'ar';

  return (
    (isArabic ? apiError?.arDescription : apiError?.description) ??
    apiError?.message ??
    fallback ??
    ''
  );
};
